// src/axios/services/balneario.js
import BaseService from "./baseService";

const balnearioService = new BaseService("fiestapopular");

export default balnearioService;
